import { useEffect, useState } from 'react';
import styles from './StarRating.module.scss';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import PropTypes from 'prop-types';
import { useLabel, useId } from 'react-aria';
import FormGroup from 'client/components/GDS/FormGroup/FormGroup';
import Star from './Star';

const StarRating = (props) => {
    const [starValues, setStarValues] = useState([]);
    const { labelProps, descriptionProps, errorMessageProps } = useLabel({ ...props });
    const ratingId = useId(props.id);

    useEffect(() => {
        const newValues = [];
        for (let starNumber = 1; starNumber <= props.numberOfStars; starNumber++) {
            newValues.push({ value: starNumber, id: ratingId + '-rating-' + starNumber.toString() });
        }
        setStarValues(newValues);
    }, [props.numberOfStars]);

    const onRatingChange = (e) => {
        props.onChange && props.onChange({ id: ratingId, name: ratingId, value: e.target.value });
    };

    return <FormGroup className={styles.formGroup} id={ratingId} label={props.label} labelProps={labelProps} labelAsTitle={props.labelAsTitle} description={props.description} descriptionProps={descriptionProps} errorMessage={props.errorMessage} errorMessageProps={errorMessageProps} {...props}>
        <div className={styles.starRatings} role="radiogroup" aria-label={props.ariaLabel}>
            <div className={styles.ratingCaption}>
                <h3 className={styles.captionHeading}>{props.lowRating}</h3>
                <h3 className={[styles.excellentCaptionInline, styles.captionHeading].join(' ')}>{props.highRating}</h3>
            </div>
            <div className={styles.starRating} >
                <div onChange={onRatingChange}>
                    { starValues.map((starValue) => {
                        return <Star key={starValue.id} id={starValue.id} value={starValue.value} parentId={ratingId}><span>{starValue.value}</span></Star>;
                    })}
                </div>
            </div>
            <h3 className={[styles.excellentCaptionSeparate, styles.captionHeading].join(' ')}>{props.highRating}</h3>
        </div>
    </FormGroup>;
};

StarRating.propTypes = {
    ...defaultAriaProps,
    id: PropTypes.string,
    numberOfStars: PropTypes.number.isRequired,
    label: PropTypes.string,
    ariaLabel: PropTypes.string,
    labelAsTitle: PropTypes.bool,
    description: PropTypes.string,
    onChange: PropTypes.func,
    highRating: PropTypes.string.isRequired,
    lowRating: PropTypes.string.isRequired
};

StarRating.defaultProps = {
    numberOfStars: 5,
    labelAsTitle: false
};

export default StarRating;
